<template>
  <div>
    <Modal
      v-model="modalShow"
      :title="title"
      footer-hide
      width="800"
      @on-cancel="cancel"
      class-name="no-adding-modal">
      <codemirror ref="showCm" v-model="content" :options="showCmOptions" @keyup.enter.native="enter"></codemirror>
      <span> 选择容器: </span>
      <Select v-model="selContainer"  placeholder="请选择Pod里面要执行命令的容器" style="width:300px">
          <Option v-for="(item, index) in containers" :value="item" :key="index">{{ item }}</Option>
      </Select>
        <!-- <Button type="primary" :loading="execIng" style="margin-right: 8px" @click="execOk">执行</Button>
        <Button @click="modalShow = false">取消</Button> -->
    </Modal>
  </div>
</template>

<script>
import { execPod } from '@/api/cloud'
import { scriptTypeChange } from '../../ops-center/scriptTools'
import codemirror from '../../ops-center/scriptUse.js'

export default {
  name: 'exec-show',
  components: {
    codemirror
  },
  data () {
    return {
      modalShow: false,
      title: '脚本',
      content: '#',
      cmd: '',
      execIng: false,
      pod: null,
      containers: [],
      selContainer: '',
      showCmOptions: {
        mode: {
          name: 'shell'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'monokai',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      }
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.showCm.editor
      editor.setSize('100%', 800)
      editor.refresh()
      return editor
    }
  },
  methods: {
    cancel () {
      this.content = '#'
    },
    enter () {
      this.cmd = this.content.split('#')[this.content.split('#').length - 1]
      this.execOk()
    },
    execOk () {
      if (this.selContainer) {
        let data = {
          name: this.pod.name,
          namespace: this.pod.namespace,
          cmd: this.cmd,
          container: this.selContainer
        }
        execPod(data).then(res => {
          if (res.status === 200) {
            this.$Message.success('执行成功')
            // 结果回写到content里面 展示在界面上
            this.content += res.data.data + '#'
            this.keepLastIndex()
          } else {
            this.$Message.error('执行失败')
          }
        })
      } else {
        this.$Message.error('请选择一个容器执行命令')
      }
    },
    keepLastIndex () {
      let editor = this.$refs.showCm.editor
      let curposition = editor.getCursor()
      console.log(curposition)
      this.$nextTick(() => {
        editor.setCursor(editor.lastLine(), 1)
      })
    },
    openModal (data) {
      console.log(data)
      this.pod = data.row
      this.containers = data.row.containers
      console.log(data.row.containers)
      if (!data) {
        this.$Notice.warning({ title: 'Pod里面无要执行的容器' })
        return false
      }
      this.title = 'Pod名称： ' + data.row.name
      this.modalShow = true
    },
    typeChange (value) {
      const lang = scriptTypeChange(value)
      this.myCodeMirror.setOption('mode', { name: lang })
    }
  }
}
</script>

<style lang="less">
  @import '../../ops-center/base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .CodeMirror{
    font-size: 15px;
  }
  .CodeMirror-fullscreen {
    z-index: 999 !important;
  }
  .CodeMirror-hints {
    z-index: 1000 !important;
  }
  .no-adding-modal .ivu-modal-body {
    padding: 0;
  }
</style>
